import { Card } from '../../ui';
import { useTranslation } from '../../../../lib/i18n';
import styles from './mobile.module.css';

/**
 * The Wearables channel, mobile: two status rows, same content and availability split as desktop's
 * `WEARABLE_CARDS` (ChannelsBody.tsx) and both native `WearablesSection`s — Siri & AirPods (available),
 * Apple Watch & Wear OS (coming soon). Neither row carries a CTA: there is nothing to tap, Siri is set up
 * in Apple's own Shortcuts app.
 */
export function WearablesMobile() {
  const { t } = useTranslation();
  return (
    <div className={styles.channelBody}>
      <Card variant="sunken" disablePadding className={styles.wearableRow}>
        <span className={styles.wearableTitle}>{t('connectors.wearables.siri')}</span>
        <span className={styles.wearableState}>{t('connectors.state.available')}</span>
      </Card>
      <Card variant="sunken" disablePadding className={styles.wearableRow}>
        <span className={styles.wearableTitle}>{t('connectors.wearables.watch')}</span>
        <span className={styles.wearableState}>{t('connectors.state.notAvailableYet')}</span>
      </Card>
    </div>
  );
}
